import { TokenStore } from 'shared-utils';

const tokenStore = new TokenStore();

export default tokenStore;